import React from "react";
import { withRouter } from "react-router-dom";

// react-router-dom 5.0.1 hat noch keine Hooks (useLocation kam erst mit
// 5.1) - daher withRouter statt useLocation.
// Feuert bei jedem Routenwechsel (inkl. dem allerersten Laden, da
// send_page_view in index.html deaktiviert ist) ein GA4 page_view-Event.
class GAPageView extends React.Component {
  componentDidMount() {
    this.firePageView();
  }

  componentDidUpdate(prevProps) {
    const prevPath = prevProps.location.pathname + prevProps.location.search;
    const currentPath = this.props.location.pathname + this.props.location.search;
    if (prevPath !== currentPath) {
      this.firePageView();
    }
  }

  firePageView() {
    if (typeof window.gtag !== "function") return;
    const { location } = this.props;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title
    });
  }

  render() {
    return null;
  }
}

export default withRouter(GAPageView);
